import { Box, useMediaQuery, type BoxProps } from "@chakra-ui/react";
import { useCallback, useEffect, useId, useRef, useState } from "react";

export const useIsTouchScreen = () => useMediaQuery("(hover: none)")[0];

export const useTouchDetails = <Key,>() => {
  const [openKey, setOpenKey] = useState<Key | null>(null);
  const regionRef = useRef<HTMLDivElement>(null);
  const detailsId = useId();
  const close = useCallback(() => setOpenKey(null), []);

  useEffect(() => {
    if (openKey === null) return;
    const closeOnTapElsewhere = (event: MouseEvent) => {
      if (!regionRef.current?.contains(event.target as Node)) close();
    };
    document.addEventListener("click", closeOnTapElsewhere);
    return () => document.removeEventListener("click", closeOnTapElsewhere);
  }, [openKey, close]);

  const triggerProps = (key: Key) => ({
    onClick: () => setOpenKey((open) => (open === key ? null : key)),
    "aria-expanded": openKey === key,
    "aria-controls": detailsId,
  });

  return { regionRef, openKey, close, triggerProps, detailsId };
};

export const InPageDetails = (props: BoxProps) => (
  <Box bg="smBackground" borderWidth="1px" borderColor="smBorder" borderRadius="md" p="3" fontSize="sm" {...props} />
);
